import { Collapse } from 'bootstrap';

class PackagesListing {

    constructor(el) {
        this.el = el;
        this.panels = [];
        let find = el.querySelectorAll('.panel.package--panel');
        let qtyKey = el.dataset.quantityKey;
        let priceTypeKey = el.dataset.pricingTypeKey;
        if(find != null) {
            // store them
            find.forEach(f => {
                this.panels.push({
                    el: f,
                    quantityKey: qtyKey,
                    pricingTypeKey: priceTypeKey,
                    formOptionControls: f.querySelectorAll(".voucher-types--option input"),
                    formNumberControl: f.querySelector('.package--controls .form-number-control'),
                    formNumberControlInput: f.querySelector('.package--controls .form-number-control input'),
                    collapseArea: Collapse.getOrCreateInstance(f.querySelector('.package--controls .package--continue'), {
                        toggle: false
                    }),
                    continueButton: f.querySelector('.package--continue .btn')
                });
            });
            // loop through
            let _this = this;
            for (let x = 0, l = this.panels.length; x < l; x++) {
                let t = this.panels[x];
                // is there a threshold setting (for packages)
                let threshold = t.formNumberControlInput.dataset.threshold;
                t.threshold = typeof(threshold) != 'undefined' ? parseInt(threshold) : 1;
                // set open/closed state
                this.checkControl(x);
                // add listeners
                t.formNumberControlInput.addEventListener('change', (e) => {
                    _this.checkControl(x);
                }, false);
                t.formOptionControls.forEach(o => {
                    o.addEventListener('click', (e) => {
                        let continueUri = new URL(t.continueButton.href, window.location.origin);
                        continueUri.searchParams.set(t.pricingTypeKey, e.currentTarget.value);
                        t.continueButton.href = continueUri.href;
                    });
                });
            }
        }
    }

    checkControl(getIndex) {
        let t = this.panels[getIndex];
        if(parseInt(t.formNumberControlInput.value) >= t.threshold) {
            // open
            t.collapseArea.show();
            t.continueButton.removeAttribute('disabled');

            let continueUri = new URL(t.continueButton.href, window.location.origin);
            continueUri.searchParams.set(t.quantityKey, t.formNumberControlInput.value);
            t.continueButton.href = continueUri.href;

            // disable other panels
            for (let x = 0, l = this.panels.length; x < l; x++) {
                if(x != getIndex) {
                    this.panels[x].el.classList.add('fade');
                    this.panels[x].formNumberControl.querySelectorAll('input, button').forEach(i => {
                        i.setAttribute('disabled', true);
                    });
                }
            }
        } else {
            // close
            t.collapseArea.hide();
            t.continueButton.setAttribute('disabled', true);
            // enable other panels
            for (let x = 0, l = this.panels.length; x < l; x++) {
                this.panels[x].el.classList.remove('fade');
                this.panels[x].formNumberControl.querySelectorAll('input, button').forEach(i => {
                    i.removeAttribute('disabled');
                });
            }
        }
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new PackagesListing(node);
        }
    });
}